import useTranslation from "next-translate/useTranslation";

import { ComponentErrorBoundary } from "shared/components/atoms/ComponentErrorBoundary";
import Carousel from "shared/components/organisms/Carousel";

const Authors = ({ authors }) => {
  const { t } = useTranslation();

  return (
    authors?.data?.length > 0 && (
      <ComponentErrorBoundary>
        <Carousel
          blackAndWhite
          className="dashboard-authors-slider"
          zIndex={25}
          context="user"
          items={authors?.data}
          sectionLink={null}
          sectionDescription={t("common:seeAllUsers")}
          sectionTitle={t("common:teachers")}
          style={{ marginTop: "2rem" }}
        />
      </ComponentErrorBoundary>
    )
  );
};

export default Authors;
